import {
  GET_STARTUP_PAGE_ATTEMPT,
  GET_STARTUP_PAGE_FAILURE,
  GET_STARTUP_PAGE_SUCCESS,
  CANNOT_INVEST_ATTEMPT,
  CANNOT_INVEST_SUCCESS,
  CANNOT_INVEST_FAILURE,
  CLEAR_STARTUP_PAGE_ERROR,
  CLEAR_STATE,
} from './actionTypes';

export const initialState = {
  startupPage: null,
  attempting: false,
  errorCode: null,  
  attemptingCI: false,
  errorCodeCI: null,
};

export const StartupPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_STARTUP_PAGE_ATTEMPT:
      return {
        ...state,
        startupPage: null,
        attempting: true,
        errorCode: null,
      };
    case GET_STARTUP_PAGE_FAILURE:
      return {
        ...state,
        startupPage: null,
        errorCode: action.errorCode,
        attempting: false,
      };
    case GET_STARTUP_PAGE_SUCCESS:
      return {
        ...state,
        startupPage: action.startupPage,
        errorCode: null,
        attempting: false,
      };

    case CANNOT_INVEST_ATTEMPT:
      return {
        ...state,
        attemptingCI: true,
        errorCodeCI: null,
      };
      
    case CANNOT_INVEST_FAILURE:
      return {
        ...state,
        errorCodeCI: action.errorCode,
        attemptingCI: false,
      };

    case CANNOT_INVEST_SUCCESS:
      return {
        ...state,
        errorCodeCI: null,
        attemptingCI: false,
      };

    case CLEAR_STARTUP_PAGE_ERROR:
      return {
        ...state,
        errorCode: null,
        attempting: false,
      };
    case CLEAR_STATE:
      return {
        initialState,
      };
    default:
      return state;
  }
};
